import { isZeroResourcePool } from "../resources/resource-pool";
import { getSupplySnapshot } from "../selectors/supply";
import type { ActionValidationFailure, ActionValidationResult, GameState } from "../types";

function invalid(
  code: ActionValidationFailure["code"],
  message: string,
  path: string | null = null,
  details: ActionValidationFailure["details"] = {},
): ActionValidationResult {
  return { valid: false, failure: { code, message, path, details } };
}

export function validateAdvancePhaseAction(state: Readonly<GameState>): ActionValidationResult {
  if (state.schemaVersion === 5) {
    return invalid(
      "ACTION_NOT_IMPLEMENTED",
      "Public-beta turns use End Turn instead of legacy phase advancement.",
      "type",
      { requiredActionType: "end-turn" },
    );
  }
  if (state.schemaVersion !== 3 && state.schemaVersion !== 4) return { valid: true };

  if (
    state.phase === "land" &&
    !isZeroResourcePool(state.players[state.activePlayerId].kingdomPool)
  ) {
    return invalid(
      "KINGDOM_POOL_NOT_EMPTY",
      "The current Kingdom Pool must be empty before Supply begins.",
      `players.${state.activePlayerId}.kingdomPool`,
      { playerId: state.activePlayerId, turnNumber: state.turnNumber },
    );
  }

  if (state.phase === "supply" && state.supplyStatus.type !== "resolved") {
    const snapshot = getSupplySnapshot(state);
    return invalid(
      "SUPPLY_UPKEEP_UNRESOLVED",
      "Supply cannot advance while local Army Upkeep remains unresolved.",
      "supplyStatus",
      {
        unsustainableLaneCount: snapshot.unsustainableLaneIds.length,
        laneIds: snapshot.unsustainableLaneIds.join(","),
      },
    );
  }

  return { valid: true };
}
